import { Outlet, useLocation } from "react-router-dom";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import type { PortfolioSiteData } from "../types/resume";

interface LayoutProps {
  data: Partial<PortfolioSiteData>;
}

const Layout = ({ data }: LayoutProps) => {
  const location = useLocation();
  if (!data?.main) {
    return (
      <div className="bg-slate-900 text-slate-200 min-h-screen flex items-center justify-center font-sans">
        <div className="text-xl font-semibold">Loading...</div>
      </div>
    );
  }

  return (
    <div className="bg-slate-900 text-slate-300 font-sans antialiased">
      <Header key={location.pathname} /> 

      <main>
        <Outlet context={{ data }} />
      </main>

      <Footer data={data.main} />
    </div>
  );
};

export default Layout;
